import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./pages/Home";
import Analysis from "./pages/Analysis";
import Database from "./pages/Database";
import Contact from "./pages/Contact";
import Installation from "./pages/Installation";
import FAQ from "./pages/Faq";

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <header className="bg-[#538249] text-white p-4 shadow-md">
          <div className="container mx-auto flex justify-between items-center">
            {/* Logo and Title - Now Clickable */}
            <Link to="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
              <img 
                src="/logo.png" 
                alt="PlasAnn Logo" 
                className="h-14 w-14 object-contain"
              />
              <h1 className="text-3xl font-bold">PlasAnn</h1>
            </Link>
            
            <nav className="space-x-6">
              <Link to="/" className="text-lg font-medium hover:underline">Home</Link>
              <Link to="/analysis" className="text-lg font-medium hover:underline">Analysis</Link>
              <Link to="/database" className="text-lg font-medium hover:underline">Database</Link>
              <Link to="/installation" className="text-lg font-medium hover:underline">Installation</Link>
              <Link to="/contact" className="text-lg font-medium hover:underline">Contact Us</Link>
              {/* OPTIONAL: Add FAQ to navigation menu */}
              {/* <Link to="/faq" className="text-lg font-medium hover:underline">FAQ</Link> */}
            </nav>
          </div>
        </header>

        <main className="container mx-auto p-6">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/analysis" element={<Analysis />} />
            <Route path="/database" element={<Database />} />
            <Route path="/installation" element={<Installation />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>
        </main>

        <footer className="bg-[#538249] text-white p-6 mt-12">
          <div className="container mx-auto flex justify-between items-center">
            <div className="text-lg font-medium">
              Funded by NIH Grant 1R35GM150871
            </div>
            <div className="text-lg font-medium">
              &copy; {new Date().getFullYear()} PlasAnn. All rights reserved.
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;